import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const WhyChoose = () => {
    const { t } = useLanguage();

    const benefits = [
        {
            icon: '⚡',
            title: t('whyChoose.benefits.productivity.title'),
            stat: '30%',
            description: t('whyChoose.benefits.productivity.description')
        },
        {
            icon: '🔓',
            title: t('whyChoose.benefits.unlock.title'),
            description: t('whyChoose.benefits.unlock.description')
        },
        {
            icon: '🛡️',
            title: t('whyChoose.benefits.security.title'),
            description: t('whyChoose.benefits.security.description')
        },
        {
            icon: '🤝',
            title: t('whyChoose.benefits.support.title'),
            description: t('whyChoose.benefits.support.description')
        }
    ];

    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#FFFFFF',
        },
        container: {
            maxWidth: '1400px',
            margin: '0 auto',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '60px',
            textAlign: 'center',
            color: '#2B2B2B',
        },
        highlight: {
            background: 'linear-gradient(135deg, #3457D5 0%, #F28C46 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '24px',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '40px 28px',
            borderRadius: '20px',
            border: '1px solid #E5E5E5',
            textAlign: 'center',
            transition: 'all 0.3s',
        },
        icon: {
            fontSize: '48px',
            marginBottom: '16px',
            display: 'block',
        },
        cardTitle: {
            fontSize: '20px',
            fontWeight: '700',
            color: '#2B2B2B',
            marginBottom: '8px',
        },
        stat: {
            fontSize: '40px',
            fontWeight: '800',
            background: 'linear-gradient(135deg, #3457D5 0%, #F28C46 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '8px',
        },
        cardDesc: {
            fontSize: '14px',
            color: '#6E6E6E',
            lineHeight: '1.6',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.grid.gridTemplateColumns = 'repeat(2, 1fr)';
    }

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <h2 style={styles.h2}>
                    {t('whyChoose.title')}<span style={styles.highlight}>{t('whyChoose.titleHighlight')}</span>
                </h2>

                <div style={styles.grid}>
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            style={styles.card}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(52,87,213,0.15)';
                                e.currentTarget.style.borderColor = '#3457D5';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.borderColor = '#E5E5E5';
                            }}
                        >
                            <span style={styles.icon}>{benefit.icon}</span>
                            <h3 style={styles.cardTitle}>{benefit.title}</h3>
                            {benefit.stat && <div style={styles.stat}>{benefit.stat}</div>}
                            <p style={styles.cardDesc}>{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;
